import { useContext } from 'react';
import { UsageScreenContext } from '../context/UsageScreenContext';
export function useUsageScreen() {
  return useContext(UsageScreenContext) || {};
}